/** Intervalles minimums — mutualisé OVH (aligné front public). */
export const MIN_POLL_MS = 30_000;

export const CONVERSATIONS_UNREAD_POLL_MS = 60_000;
export const CONVERSATIONS_LIST_POLL_MS = 60_000;
export const CONVERSATION_DETAIL_POLL_MS = MIN_POLL_MS;
export const FOUND_OBJECT_STATS_POLL_MS = 120_000;

export const POLLING_IDLE_TIMEOUT_MS = 5 * 60 * 1000;
export const CIRCUIT_BREAKER_PAUSE_MS = 5 * 60 * 1000;
export const CIRCUIT_BREAKER_FAILURE_THRESHOLD = 3;

export const CIRCUIT_BREAKER_HTTP_CODES = new Set([429, 502, 503, 504]);
